(function (window) {
  'use strict';

  const inquirySelect = document.getElementById('contact-us-inquiry-reason');
  const golfIdSelect = document.getElementById('contact-us-golf-id');
  const golfIdOtherInput = document.getElementById('contact-us-golf-id-other');
  const disabledFormItemClass = 'form-item--disabled';

  // Shows/hides additional form options related to the selected Inquiry option.
  function handleInquiryChange(e) {
    const newValue = e.target.value;
    const optionContainers = document.querySelectorAll('.js-contact-us-additional-options');

    for (let i = 0; i < optionContainers.length; i++) {
      const optionContainer = optionContainers[i];

      if (newValue == optionContainer.getAttribute('data-options-id')) {
        optionContainer.classList.remove('js-hidden');
      }
      else {
        optionContainer.classList.add('js-hidden');
      }
    }
  }

  function handleGolfIdChange(e) {
    if (e.target.value == 'other') {
      enableGolfIdOther();
    }
    else {
      disableGolfIdOther();
    }
  }

  function enableGolfIdOther() {
    golfIdOtherInput.removeAttribute('disabled');
    golfIdOtherInput.closest('.form-item').classList.remove(disabledFormItemClass);
  }

  function disableGolfIdOther() {
    golfIdOtherInput.setAttribute('disabled', '');
    golfIdOtherInput.closest('.form-item').classList.add(disabledFormItemClass);
  }

  if (inquirySelect) {
    inquirySelect.addEventListener('change', handleInquiryChange);
  }

  if (golfIdSelect && golfIdOtherInput) {
    golfIdSelect.addEventListener('change', handleGolfIdChange);
    disableGolfIdOther();
  }

})(this);
